import IFACE, { EL } from './IFACE.js';
import Disable from '../event/Disable.js';
import Enable from '../event/Enable.js';
/** A series of Enable/Disable Related Events and Methods
    By default, a disableable element is enabled
    Typically, the Enable/Disable events are used to disable Form Elements within an Element
*/
export default class Disableable extends IFACE {
    constructor(node) {
        super(node, 'disableable');
        //node.setAttribute('disabled', true);
    }
    addListeners(node) {
        node.on('disable', () => node.disable());
        node.on('enable', () => node.enable());
    }
    setMethods(node) {
        /** Disables elements within the node
            @returns {Promise<ThisType>} Promise Chain
        */
        this.methods.disable = () => node.chain(() => {
            node.setAttribute('disabled', true);
            node.addClass('disabled');
        });
        /** Enables elements within the node
            @returns {Promise<ThisType>} Promise Chain
        */
        this.methods.enable = () => node.chain(() => {
            node.removeAttribute('disabled');
            node.removeClass('disabled');
        });
        this.methods.toggleDisabled = () => node.chain(() => {
            if (node.el.hasAttribute('disabled')) {
                node.do(new Enable(node));
            }
            else {
                node.do(new Disable(node));
            }
        });
    }
}
export { Disable, EL, Enable, IFACE };
